import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { useHomeStore } from 'context/HomeStore'
import { useChatStyles } from './chat.styles'
import { NoAssign } from './components/NoAssign/NoAssign'
import { ChatMessage } from './components/ChatMessage/ChatMessage'
import { ChatInput } from './components/ChatInput/ChatInput'

const ChatCard = () => {
  const classes = useChatStyles()

  const {
    homeStore: { requestList }
  } = useHomeStore()

  return (
    <Grid item container>
      <Grid item container xs={12} md={12} style={{ marginBottom: 18 }}>
        <Typography variant="subtitle1">Чат с поддержкой</Typography>
      </Grid>
      <Grid
        item
        container
        direction={'column'}
        className={classes.chatContainer}
      >
        {!requestList.adminFullname && (
          <Grid item container style={{ height: '100%' }}>
            <NoAssign />
          </Grid>
        )}
        {!!requestList.adminFullname && (
          <Grid item>
            <ChatMessage />
          </Grid>
        )}
      </Grid>
      <ChatInput />
    </Grid>
  )
}

export default ChatCard
